import { ProcedureFormBase } from "./procedure-form.model";

export class ProcedureBase {
    id!: number;
    name!: string;
    code!: string;

    static from(source: Procedure): ProcedureBase {

        let current = new ProcedureBase();
        Object.assign(current, source);

        return current;
    }

}

export interface Procedure extends ProcedureBase {

}